import { useState } from "react";

import { Box, Button, Stack, Typography } from "@mui/material";

import { useAvaContext } from "./AvaContext";
import { avaPeriods } from "./consts";
import { MoreOptionsMenu } from "./MoreOptionsMenu";
import { extractAttachments } from "./utils";

export const ChatHistory = () => {
  const [hoveredConversationId, setHoveredConversationId] = useState<string | null>(null);

  const { history } = useAvaContext();

  const { setConversationId } = useAvaContext();

  return (
    <Stack sx={{ borderRight: "1px solid", borderColor: "divider" }}>
      <Stack spacing={3} width={350} height="100%" py={2} sx={{ overflowY: "auto" }}>
        <Typography variant="subtitle2" fontWeight={500} pb={0.5} px={2}>
          Chat history
        </Typography>
        {Object.entries(history).map(([period, conversations]) => (
          <Stack key={period}>
            <Typography variant="caption" fontWeight={500} px={2}>
              {avaPeriods[period]}
            </Typography>
            {conversations.map((conversation) => (
              <Stack
                key={conversation.conversationId}
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                onMouseEnter={() => {
                  setHoveredConversationId(conversation.conversationId);
                }}
                onMouseLeave={() => {
                  setHoveredConversationId(null);
                }}
                spacing={0.5}
                height={32}
                sx={{
                  pl: 2.5,
                  pr: 2,
                  ":hover": {
                    backgroundColor: "primary.hoverBackground",
                  },
                }}
              >
                <Typography
                  variant="body2"
                  noWrap
                  onClick={() => {
                    setConversationId(conversation.conversationId);
                  }}
                  sx={{ cursor: "pointer", py: "9px", maxWidth: 300 }}
                >
                  {extractAttachments(conversation.title).cleanedMessage}
                </Typography>
                {hoveredConversationId === conversation.conversationId && (
                  <MoreOptionsMenu conversationId={conversation.conversationId} />
                )}
              </Stack>
            ))}
          </Stack>
        ))}
      </Stack>
      <Box
        px={2}
        py={2.77}
        sx={{
          borderTop: "1px solid",
          borderColor: "divider",
          backgroundColor: "background.default",
        }}
      >
        <Button
          variant="outlined"
          sx={{
            width: "-webkit-fill-available",
          }}
          onClick={() => {
            setConversationId();
          }}
        >
          Start new chat
        </Button>
      </Box>
    </Stack>
  );
};
